import { Divider, Paper, TextField, Typography } from "@material-ui/core";
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect, useState } from "react";
import { toogleButton, unoTheme } from "../../../assets/styles/unoTheme";
import UnoButton from "../../utils/UnoButton";

import IconButton from '@material-ui/core/IconButton';

import CloseIcon from '@material-ui/icons/Close';

import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';

import MyAutoComplete from '../../utils/MyAutoComplete';
import AddIcon from '@material-ui/icons/Add';

//Redux
import { useDispatch, useSelector } from "react-redux";
import allActions from "../../../actions";
import MySwitch from '../../utils/MySwitch';
import DeleteIcon from '@material-ui/icons/Delete';

import {
    applyMaskAccount,
    applyMaskAmount,
    formatStringToDisplay,
    getOperationColor,
    isDateAfterClosedMonth,
    isDateBeforeInit,
    MAX_APR_DESCRIPTION_LENGTH,
    parseFloatByPtCurrency
} from "../../utils/utils";

//API
import { FundAPI } from "../../../API/fund";
import { TransactionAPI } from "../../../API/transaction";

import InputAdornment from '@material-ui/core/InputAdornment';

//RadioGroup
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';

//MyInputs
import MyDatePicker from '../../utils/MyDatePicker';
import MyRadioGroup from '../../utils/MyRadioGroup';
import MySelect from '../../utils/MySelect';
import MyTextField from "../../utils/MyTextField";

import CircularProgress from '@material-ui/core/CircularProgress';

import ArrowBackIcon from '@material-ui/icons/ArrowBack';

import moment from 'moment';
import MyInfo from "../../utils/MyInfo";

import ConfirmActionRightContent from './ConfirmActionRightContent';

import {
    doCheckHasCotaDayFund
} from "../../../controllers/FundLocalQuotasController";
import { checkUserIsRole, roles } from "../../utils/user";
import { useMemo } from "react";
import { ClientAPI } from "../../../API/client";
import { isConsigTitle } from "../../../controllers/TitleController";


const useStyles = makeStyles((theme) => ({
    root: {
        //height: '100vh',
        width: '100%',
    },

    header: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: theme.spacing(3),
        background: unoTheme.hoverTable
    },

    main: {
        height: 'calc(100% - 126px)',
        display: 'flex',
        flexDirection: 'column',
        paddingTop: theme.spacing(5),
        paddingLeft: theme.spacing(5),
        paddingRight: theme.spacing(5),
        paddingBottom: theme.spacing(5),
        textAlign: 'left',
        overflowY: "scroll",

        '& .MuiPaper-root': {
            height: 'calc(100% - 184px)',
        }
    },

    labelCellTop: {
        fontSize: '13px',
        fontWeight: '600'
    },
    labelCellBottom: {
        fontSize: '13px',
        fontColor: unoTheme.defaultTextColor
    },

    bottom: {
        display: 'flex',
        alignItems: 'flex-end',
        flexDirection: 'column',
        justifyContent: 'flex-end',

        '& .bottomButtons': {
            paddingTop: theme.spacing(2),
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        }

    },

    spacingRight2: {
        marginRight: theme.spacing(2),
    },

    table: {
        '& .MuiTableRow-head': {
            '& .MuiTableCell-root': {
                borderBottom: 'none',
                color: unoTheme.defaultTextColor,
                fontWeight: '500',
                textTransform: 'uppercase',
                fontSize: '12px',
                padding: '16px',
            },
        },
    },

    detailRow: {
        cursor: "pointer",
        '& > *': {
            borderBottom: 'unset',
            padding: '3px 16px 3px 16px !important',
            textTransform: 'uppercase',
            color: unoTheme.defaultTextColor,
            fontWeight: 400,
            fontSize: '12px',
        },
        '&:nth-of-type(odd)': {
            backgroundColor: unoTheme.secondaryTuplaTable,
        },

    },

    flexCell: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        justifyItems: 'center',
        height: '100%',
        paddingLeft: '0px !important',

        '& .MuiTypography-root': {
            fontWeight: 400,
            fontSize: '12px',
        },
    },
    statusOff: {
        color: unoTheme.greenMoney,
        fill: unoTheme.greenMoney,
    },
    statusOk: {
        color: unoTheme.greenMoney,
        fill: unoTheme.greenMoney,
    },
    statusPendent: {
        color: unoTheme.warningColor,
        fill: unoTheme.warningColor,
    },
    marginLeft: {
        marginLeft: '5px',
    },
    leftHeader: {

        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    labelYear: {
        fontSize: '36px',
        paddingRight: theme.spacing(2),
    },
    spacingLeft2: {
        marginLeft: theme.spacing(2)
    },

    disableMonth: {
        position: 'absolute',
        height: '100%',
        width: '100%',
    },
    green: {
        color: unoTheme.greenMoney
    },
    red: {
        color: unoTheme.errorColor,
    },
    warning: {
        color: unoTheme.warningColor
    },
    hiddenIcon: {
        visibility: 'hidden',
    },
    rightDivBackdrop: {
        backgroundColor: 'white',
        position: 'absolute',
        opacity: 0.7,
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

        '& .progress': {
            color: unoTheme.mainColor
        }
    },
    validationMessage: {
        color: unoTheme.errorColor,
        fontSize: '14px',
        textAlign: 'right',
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
    },

    toogleButton: toogleButton,

    redInput: {
        '& input': {
            color: unoTheme.redMoney,
        }
    },

    greenInput: {
        '& input': {
            color: unoTheme.greenMoney,
        }
    },

    blueInput: {
        '& input': {
            color: "blue !important",
        }
    },


}));

export default function NewTransaction(props) {

    const classes = useStyles();
    const dispatch = useDispatch();

    const clientOn = useSelector(state => state.clientOn)
    const currentUser = useSelector(state => state.currentUser)

    const { content } = props
    console.log("Content: ", content);

    //const [edittingIndex, setEdittingIndex] = useState(undefined);
    const [submitted, setSubmitted] = useState(false);
    const [confirmingAction, setConfirmingAction] = useState(false);

    const [openBackdrop, setOpenBackdrop] = useState(false);
    const [validationMessage, setValidationMessage] = useState('');
    const [fundClientAccounts, setFundClientAccounts] = useState([]);


    //form
    const [inputFundNewTransaction, setInputFundNewTransaction] = React.useState();
    const [inputAccountNewTransaction, setInputAccountNewTransaction] = React.useState(undefined);
    const [inputQuotasNewTransaction, setInputQuotasNewTransaction] = useState("");
    const [descriptionsApr, setDescriptionsApr] = useState([]);

    //Title
    const [inputTitleNewTransaction, setInputTitleNewTransaction] = React.useState(0);
    const [inputAssetTitleNewTransaction, setInputAssetTitleNewTransaction] = React.useState(0);
    const [titleClientAccounts, setTitleClientAccounts] = useState([]);

    const [option, setOption] = useState('fund');
    const handleSelect = (event, newOption) => {

        if (newOption && newOption.length) {

            //console.log("NEW OPTION: ", newOption);

            if (newOption === 'fund') {

                setInputFundNewTransaction();
                // setInputOperationNewTransaction(1);
                const fundId = content.data.fund?.fund_id || content.data.funds[0].id;
                loadFundAccounts(fundId,
                    clientOn.client.id, undefined);

            } else {

                setInputTitleNewTransaction(0);
                // setInputOperationNewTransaction(3);

            }

            setOption(newOption);
        }


    };

    ////////////////////////////
    //DYNAMIC INPUT TRANSACTIONS
    ////////////////////////////
    // const initDateInput = useMemo(() => {
    //     if (clientOn?.client?.portfolio_closed) {
    //         const splittedDate = clientOn.client.portfolio_closed.split('/');
    //         return new Date(parseInt(splittedDate[1]), parseInt(splittedDate[0]), 1, 0, 0, 0, 0);
    //     }
    //     return new Date();
    // }, [clientOn])
    const initDateInput = useMemo(() => {
        if (clientOn?.client?.selectedMonth && clientOn?.client?.selectedYear) {

            return new Date(parseInt(clientOn.client.selectedYear), parseInt(clientOn.client.selectedMonth) - 1, 1, 0, 0, 0, 0);
        }
        return new Date();
    }, [clientOn])

    const defaultInputTransaction = {
        date: initDateInput,
        amount: "",
        operationId: 1,
        isTransfer: false,
        isSplit: false,
        descriptionAprSelected: 0,
        aprDescription: "",
    }

    const handleAddInputDateAndValueFund = () => {
        const currentInputs = [...inputsDatesAndValuesFundTransactions];
        currentInputs.push({
            ...defaultInputTransaction
        });

        setInputsDatesAndValuesFundTransactions(currentInputs)

    }

    const handleInputsToUpdate = (operationId, isTransfer, isSplit, transactionDate, amount, descriptionAprSelected, aprDescription) => {

        setInputsDatesAndValuesFundTransactions([
            {
                operationId: operationId,
                isTransfer: isTransfer,
                isSplit: isSplit,
                date: moment.utc(transactionDate),
                amount: applyMaskAmount(amount),
                descriptionAprSelected: descriptionAprSelected ?? 0,
                aprDescription: aprDescription ?? "",

            }
        ])
    }

    const handleRemoveInputDateAndValueFund = (index) => {
        const currentInputs = [...inputsDatesAndValuesFundTransactions];
        currentInputs.splice(index, 1);;
        setInputsDatesAndValuesFundTransactions(currentInputs)

    }

    const handleChangeInputDateAndValueFund = (index, type, newValue) => {

        //Obtendo estado atual        
        const currentInputs = [...inputsDatesAndValuesFundTransactions];

        //Verificando se o campo de descrição aberto não é ultrapassado
        if (type === "aprDescription") {
            currentInputs[index]["descriptionAprSelected"] = 0;
            if (newValue.length > MAX_APR_DESCRIPTION_LENGTH) {
                dispatch(allActions.mainAlertActions.setMainAlert({
                    show: true,
                    type: "warning",
                    message: `O texto de descrição de APR deve possuir no máximo ${MAX_APR_DESCRIPTION_LENGTH} caracteres`
                }))
            }
            newValue = newValue.substring(0, MAX_APR_DESCRIPTION_LENGTH)
        }

        //Atualizando descrição padrão
        if (type === "descriptionAprSelected") {
            currentInputs[index]["aprDescription"] = descriptionsApr[newValue].description
        }

        //isTransfer e isSplit são mutuamente exclusivos
        if (type === "isTransfer" && newValue === true) {
            currentInputs[index]["isSplit"] = false;
        }
        if (type === "isSplit" && newValue === true) {
            currentInputs[index]["isTransfer"] = false;
        }

        //Atualizando estado
        currentInputs[index][type] = newValue;
        setInputsDatesAndValuesFundTransactions(currentInputs)



    }

    const [inputsDatesAndValuesFundTransactions, setInputsDatesAndValuesFundTransactions] = useState([{
        ...defaultInputTransaction
    }]);

    const getInputColor = (operationId, isTransfer) => {
        if (isTransfer) {
            return "";
        }
        if (operationId === 1) {
            return classes.greenInput;
        } else if (operationId === 2) {
            return classes.redInput;
        } else {
            return classes.blueInput;
        }
    }

    const needQuotasTransaction = useMemo(() => {
        if (!content?.data) return false;
        if (content && content.data && content.data.titleAssets && content.data.titleAssets[inputAssetTitleNewTransaction]) {

            //console.log('content?.data?.titleAssets[inputAssetTitleNewTransaction]: ', content?.data?.titleAssets[inputAssetTitleNewTransaction]);
        }

        const theMainTransaction = inputsDatesAndValuesFundTransactions?.[0];

        const valueNeedQuotasTransactions = option == 'title'
            && content
            && content.data
            && content.data.titleAssets
            && content.data.titleAssets[inputAssetTitleNewTransaction]
            &&

            (

                isConsigTitle(content.data.titleAssets[inputAssetTitleNewTransaction])
                ||
                (
                    (!content.data.titleAssets[inputAssetTitleNewTransaction].with_liquidity)
                    && (
                        theMainTransaction?.operationId == 2
                        ||
                        (theMainTransaction?.operationId == 1 && content.data.titleAssets[inputAssetTitleNewTransaction].marking == "MERCADO")
                    )
                )


            )

        console.log("valueNeedQuotasTransactions: ", valueNeedQuotasTransactions);
        return valueNeedQuotasTransactions;

    }, [content, content.data, inputAssetTitleNewTransaction, inputsDatesAndValuesFundTransactions])

    const isAbleCurrentMonth = useMemo(() => {

        if (!clientOn?.client?.is_able_transactions_current_month) return false
        if (clientOn.client.is_able_transactions_current_month
            && (moment.utc(new Date()).format("M/YYYY") == (parseInt(clientOn.client.selectedMonth) + '/' + clientOn.client.selectedYear))
        ) {
            return true;
        }

    }, [clientOn?.client?.is_able_transactions_current_month])

    const renderedInputsDatesAndValues = useMemo(() => {

        const nodes = [];
        inputsDatesAndValuesFundTransactions.forEach((input, index) => {
            nodes.push(
                <Grid item lg={12}>

                    <Divider style={{ width: "100%" }} />

                </Grid>)

            nodes.push(
                <Grid item lg={8} md={8} sm={12} xs={12} className={classes.alignLeft}>
                    <MyRadioGroup
                        outerlabel={'Operação'}
                        row
                        aria-label="operação" name="operation"
                        value={input.operationId}
                        onChange={(e) => {
                            if (e.target.value == 3) {
                                handleChangeInputDateAndValueFund(index, 'isTransfer', false)
                            }
                            handleChangeInputDateAndValueFund(index, 'operationId', parseInt(e.target.value))
                        }}
                        options={content.data.operations.map((row, indexOperation) => (
                            <FormControlLabel

                                disabled={option == 'title'
                                    && inputAssetTitleNewTransaction
                                    && inputAssetTitleNewTransaction.sector == 'PUBLICO' && (indexOperation == 0 || indexOperation == 1)}
                                key={'operation-new-transaction-' + row.id}
                                value={row.id}
                                control={<Radio />}
                                label={
                                    <span className={classes.itemRegime}>{row.type_operation}</span>
                                } />
                        ))}
                    />


                </Grid>)

            nodes.push(
                <Grid item lg={2} md={2} sm={6} xs={6}>
                    <MySwitch
                        flexAlign="flex-start"
                        disabled={input.operationId === 3}
                        outerlabel={'TRANSFER?'}
                        checked={input.isTransfer}
                        onChange={(e) => handleChangeInputDateAndValueFund(index, 'isTransfer', e.target.checked)}
                        color="primary" />


                </Grid>
            )
            nodes.push(
                <Grid item lg={2} md={2} sm={6} xs={6}>
                    <MySwitch
                        flexAlign="flex-start"
                        disabled={input.operationId === 3 || option != "fund"}
                        outerlabel={'(IN)SPLIT?'}
                        checked={input.isSplit}
                        onChange={(e) => handleChangeInputDateAndValueFund(index, 'isSplit', e.target.checked)}
                        color="primary" />
                </Grid>
            )

            nodes.push(
                <Grid item lg={needQuotasTransaction ? 8 : 12} sm={12} xs={12} container spacing={0} alignItems="center">
                    <Grid item lg={6} md={6} sm={12} xs={12} className={classes.alignLeft}>
                        <MyDatePicker
                            className={classes.myDatePicker}
                            margin="dense"
                            outerlabel="Data (Cotização)"
                            format="DD/MM/YYYY"
                            value={input.date}
                            onChange={(value) => handleChangeInputDateAndValueFund(index, "date", value)}
                            KeyboardButtonProps={{ 'aria-label': 'change date', }} />

                    </Grid>


                    <Grid item lg={5}
                        md={5} sm={12} xs={12} className={classes.alignLeft}>
                        <MyTextField
                            className={getInputColor(input.operationId, input.isTransfer)}
                            align={'right'}
                            startadornment={<InputAdornment position="start">R$</InputAdornment>}
                            size={'small'}
                            outerlabel="Valor"
                            outerlabelright={'true'}
                            value={input.amount}
                            placeholder="0,00"
                            helperText={"Insira o valor da movimentação"}
                            validator={submitted && input.amount == ""}
                            onChange={(value) => handleChangeInputDateAndValueFund(index, "amount", value)}
                            mask={["currency"]} />

                    </Grid>

                    <Grid item lg={1}>
                        <IconButton disabled={inputsDatesAndValuesFundTransactions.length === 1} onClick={() => handleRemoveInputDateAndValueFund(index)} size="small" style={{ marginTop: "12px", float: "right" }}>
                            <DeleteIcon />
                        </IconButton>
                    </Grid>

                </Grid>
            )

            if (isAbleCurrentMonth) {
                nodes.push(
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <MySelect
                            outerlabel={'Títulos predefinidos'}
                            value={input.descriptionAprSelected}
                            onChange={(e) => handleChangeInputDateAndValueFund(index, "descriptionAprSelected", e.target.value)}
                            options={descriptionsApr.map((row, index) => (

                                <option style={{ display: row.active ? "block" : "none" }} key={"apr-description-" + index} value={index}>{row.title}</option>

                            ))}>

                        </MySelect>
                    </Grid>

                )
                nodes.push(
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <MyTextField
                            value={input.aprDescription}
                            onChange={(value) => handleChangeInputDateAndValueFund(index, "aprDescription", value)}
                            multiline={true}
                            rows={7}
                            rowsMax={7}
                            outerlabel={'Descrição'} />

                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '8px' }}>
                            <span style={{ fontSize: '12px' }}>Caracteres {input.aprDescription.length}/{MAX_APR_DESCRIPTION_LENGTH}</span>
                        </div>
                    </Grid>
                )
            }

        });

        return nodes;

    }, [inputsDatesAndValuesFundTransactions, needQuotasTransaction, isAbleCurrentMonth, descriptionsApr, submitted])

    ////////////////////////////////
    //FIM DYNAMIC INPUT TRANSACTIONS
    ////////////////////////////////

    async function doCreateFundTransaction() {

        setSubmitted(true);
        setValidationMessage('')
        setOpenBackdrop(true);


        if (inputAccountNewTransaction == undefined) {

            setOpenBackdrop(false);
            setValidationMessage("Uma conta deve ser selecionada")

            //Verificando se não está tentando criar uma movimentação para um mês já fechado  
        } else {
            // console.log("Fund: ", content.data.funds);
            // console.log("Input: ", inputFundNewTransaction)
            // console.log("fundClientAccounts: ", fundClientAccounts)
            // console.log("inputAccountNewTransaction: ", inputAccountNewTransaction)

            if (!inputFundNewTransaction) {
                setOpenBackdrop(false);
                setValidationMessage('Selecione o fundo!');
                return;
            }

            const filteredAssets = content.data.assets.filter(el =>
                el.fund_id == inputFundNewTransaction.id
                && el.account_id == fundClientAccounts[inputAccountNewTransaction].id)

            const transactionsToCreate = [];
            if (filteredAssets && filteredAssets.length > 0) {
                const assetId = filteredAssets[0].id;
                inputsDatesAndValuesFundTransactions.forEach(element => {
                    transactionsToCreate.push({
                        asset_id: assetId,
                        operation_id: element.operationId,
                        amount: parseFloatByPtCurrency(element.amount),
                        //transaction_date: inputDateNewTransaction,
                        is_transfer: element.isTransfer,
                        is_split: element.isSplit,
                        transaction_date: moment.utc(element.date).format("DD/MM/YYYY"),
                        apr_description_id: element.descriptionAprSelected !== 0 && descriptionsApr[element.descriptionAprSelected] ? descriptionsApr[element.descriptionAprSelected].id : null,
                        description: element.aprDescription ?? "",
                    })
                });
            }


            //console.log("TRANSACTIONS TO CREATE: ", transactionsToCreate)

            //console.log(clientOn.client.portfolio_init.substring(3));

            let portfolioInit = moment.utc(clientOn.client.portfolio_init).format("DD/MM/YYYY");

            //Verificando falta de cota para algum dia de transação

            const noDatesQuotas = [];
            const invalidDates = [];
            const dateAfterClosedMonth = [];
            const dateBeforeInit = [];
            const zeroTransactions = [];
            for (let index = 0; index < transactionsToCreate.length; index++) {
                const transactionToCreate = transactionsToCreate[index];

                //Testando existência de cota para esse dia de movimentação
                if (transactionToCreate.operation_id !== 3
                    && !filteredAssets[0].is_poupanca
                    && !checkUserIsRole(currentUser, [roles.superadmin, roles.admin])
                ) {
                    //Caso seja gestor ou subgestor e tenha permissão para lançar no mês vigente, não faz a checagem
                    if (checkUserIsRole(currentUser, [roles.manager, roles.submanager]) && isAbleCurrentMonth) {
                        continue;
                    }
                    //retirando checagem caso seja amortização //Caso seja poupança também não necessita de teste
                    const hasCota = await doCheckHasCotaDayFund(inputFundNewTransaction.id, transactionToCreate.transaction_date);
                    if (!hasCota) {

                        noDatesQuotas.push(transactionToCreate.transaction_date);
                    }
                }

                if (transactionToCreate.amount == 0 || Number.isNaN(transactionToCreate.amount)) {
                    zeroTransactions.push(transactionToCreate);
                }
                //Testando validada da data
                if (transactionToCreate.transaction_date == 'Invalid date') {

                    invalidDates.push(transactionToCreate);

                }

                //Testando se data de movimentação está após o fechamento da carteira
                if (!isDateAfterClosedMonth(
                    transactionToCreate.transaction_date,
                    clientOn.client.portfolio_closed)) {

                    dateAfterClosedMonth.push(transactionToCreate);

                }

                //Testando se data de movimentação está antes do início da carteira
                if (isDateBeforeInit(transactionToCreate.transaction_date,
                    clientOn.client.portfolio_init)) {
                    dateBeforeInit.push(transactionToCreate);
                }
            }

            // console.log("noDatesQuotas: ", noDatesQuotas);
            // console.log("invalidDates: ", invalidDates);
            // console.log("dateAfterClosedMonth: ", dateAfterClosedMonth);
            // console.log("dateBeforeInit: ", dateBeforeInit);
            // console.log("zeroTransactions: ", zeroTransactions);

            if (noDatesQuotas.length) {
                setOpenBackdrop(false);
                setValidationMessage('Não existe cota para esse fundo nos dias [ ' + noDatesQuotas.join(", ") + ' ]');
                return;
            } else if (invalidDates.length) {
                setOpenBackdrop(false);
                setValidationMessage('Existem datas inválidas informadas nas movimentações!');
                return;
            } else if (dateAfterClosedMonth.length) {
                setOpenBackdrop(false);
                setValidationMessage('A carteira já foi fechada para alguma data em que se deseja realizar a movimentação!');
                return;
            } else if (dateBeforeInit.length) {
                setOpenBackdrop(false);
                setValidationMessage('A data da movimentação deve ser a superior ao último dia do mês de ínicio da carteira do cliente ( ' + portfolioInit + ' )!');
                return;
            } else if (zeroTransactions.length) {
                setOpenBackdrop(false);
                return;
            }


            let successCount = 0;
            for (let index = 0; index < transactionsToCreate.length; index++) {
                const element = transactionsToCreate[index];
                let response = await TransactionAPI.createTransaction(element);
                if (response.success) {

                    successCount++;

                }

            }

            if (successCount === transactionsToCreate.length) {

                dispatch(allActions.mainAlertActions.setMainAlert({
                    show: true,
                    type: 'success',
                    message: "Movimentações criadas com sucesso!"
                }))
            } else if (successCount < transactionsToCreate.length) {
                dispatch(allActions.mainAlertActions.setMainAlert({
                    show: true,
                    type: 'warning',
                    message: "Ocorreram erros em uma ou mais movimentações!"
                }))
            }

            setOpenBackdrop(false);
            dispatch(allActions.rightContentActions.update())

        }

    }

    async function doCreateTitleTransaction() {

        setSubmitted(true);
        setValidationMessage('')
        setOpenBackdrop(true);

        let transactionToCreate = {}

        const input = inputsDatesAndValuesFundTransactions[0];

        if (inputAssetTitleNewTransaction != null
            && content.data.titleAssets[inputAssetTitleNewTransaction].id) {

            transactionToCreate = {
                title_asset_id: content.data.titleAssets[inputAssetTitleNewTransaction].id,
                operation_id: input.operationId,
                amount: parseFloatByPtCurrency(input.amount),
                //transaction_date: inputDateNewTransaction,

                transaction_date: moment.utc(input.date).format("DD/MM/YYYY"),
            }

            //caso o título possua liquidez e seja uma operação de resgate
            if (needQuotasTransaction) {//resgate
                transactionToCreate.quota_value = parseFloatByPtCurrency(inputQuotasNewTransaction);
            }

            // console.log("TRANSACTION TO CREATE: ", transactionToCreate)

            // console.log(transactionToCreate.transaction_date.substring(3));
            // console.log(clientOn.client.portfolio_init.substring(3));

            let portfolioInit = moment.utc(clientOn.client.portfolio_init).format("DD/MM/YYYY");

            if (transactionToCreate.transaction_date == 'Invalid date') {

                setOpenBackdrop(false);
                setValidationMessage('Data inválida!');

            } else if (!isDateAfterClosedMonth(
                transactionToCreate.transaction_date,
                clientOn.client.portfolio_closed)) {

                setOpenBackdrop(false);
                setValidationMessage('A carteira já foi fechada para a data em que se deseja realizar a movimentação!');

            } else if (isDateBeforeInit(transactionToCreate.transaction_date,
                clientOn.client.portfolio_init)) {

                setOpenBackdrop(false);
                setValidationMessage('A data da movimentação deve ser a superior ao último dia do mês de ínicio da carteira do cliente ( ' + portfolioInit + ' )!');

            } else {

                //Verificando se existe cota para esse dia de transação 
                let response = await TransactionAPI.createTransaction(transactionToCreate);
                if (response.success) {

                    dispatch(allActions.mainAlertActions.setMainAlert({
                        show: true,
                        type: 'success',
                        message: "Movimentação criada com sucesso!"
                    }))

                } else {

                    dispatch(allActions.mainAlertActions.setMainAlert({
                        show: true,
                        type: 'error',
                        message: "Erro ao criar movimentação!"
                    }))

                }

                setOpenBackdrop(false);
                dispatch(allActions.rightContentActions.update())

            }
        } else {
            setOpenBackdrop(false);
            setValidationMessage('Não existem títulos para esse título ID e essa conta ID');
        }


    }

    async function doUpdateTransaction() {

        setSubmitted(true);

        setOpenBackdrop(true);
        //const oldDateTransaction = moment.utc(transactionToUpdate.transaction_date).format('DD/MM/YYYY');

        const input = inputsDatesAndValuesFundTransactions[0];

        let transactionToUpdate = {
            id: content.transactionToUpdate.id,
            asset_id: option == 'fund' ? fundClientAccounts[inputAccountNewTransaction].asset_id : null,
            title_asset_id: option == 'title' ? content.transactionToUpdate.title_asset_id : null,
            operation_id: input.operationId,
            amount: parseFloatByPtCurrency(input.amount),
            transaction_date: moment.utc(input.date).format("DD/MM/YYYY"),
            is_transfer: input.isTransfer,
            is_split: input.isSplit,
            apr_description_id: input.descriptionAprSelected !== 0 && descriptionsApr[input.descriptionAprSelected] ? descriptionsApr[input.descriptionAprSelected].id : null,
            apr_description: input.aprDescription ?? "",

            //Caso em que deve-se atualizar a data de compra do título
            // first_application_transaction: option == 'title' ?
            //     moment.utc(content.data.titleAssets[inputAssetTitleNewTransaction].purchase_date).format("DD/MM/YYYY") == oldDateTransaction
            //     : null,
            //transaction_date: inputDateNewTransaction,
        }

        //caso o título possua liquidez e seja uma operação de resgate
        if (needQuotasTransaction) {//resgate
            transactionToUpdate.quota_value = parseFloatByPtCurrency(inputQuotasNewTransaction);
        }

        //console.log("TRANSACTION TO UPDATE: ", transactionToUpdate)

        let response = await TransactionAPI.updateTransaction(transactionToUpdate);
        if (response.success) {

            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'success',
                message: "Movimentação atualizada com sucesso!"
            }))


        } else {

            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'error',
                message: "Erro ao atualizar movimentação!"
            }))

        }

        setOpenBackdrop(false);
        dispatch(allActions.rightContentActions.update())

    }

    async function doDeleteTransaction() {

        setOpenBackdrop(true);

        let response = await TransactionAPI.deleteTransaction(content.transactionToUpdate.id);
        if (response.success) {

            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'success',
                message: "Movimentação excluída com sucesso!"
            }))


        } else {

            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'error',
                message: "Erro ao excluir movimentação!"
            }))

        }

        setOpenBackdrop(false);
        dispatch(allActions.rightContentActions.update())

    }

    async function loadFundAccounts(fundId, clientId, nowAccountId) {


        const responseDescriptions = await ClientAPI.listAprDescriptions(clientId);
        responseDescriptions.body.rows.unshift({
            title: "Editar descrição da apr",
            description: "",
            active: true,
        });

        setDescriptionsApr(responseDescriptions.body.rows != undefined ? responseDescriptions.body.rows : [])

        let response = await FundAPI.getFundClientAccountList(fundId, clientId);
        if (response.success) {


            // console.log("Setando contas: ", response.body.rows)
            let accs = response.body.rows;
            setFundClientAccounts(accs);

            //No caso de ser um update se coloca o select na conta selecionada, 
            //no caso de não ser colaca-se para a primeira conta obtida
            if (nowAccountId) {

                for (let i = 0; i < response.body.rows.length; i++) {

                    let accountLoop = response.body.rows[i];
                    if (accountLoop.id == nowAccountId) {
                        setInputAccountNewTransaction(i);
                        break;
                    }

                }

            } else {

                if (response.body.rows.length == 1) {

                    setInputAccountNewTransaction(0)

                } else {

                    setInputAccountNewTransaction(undefined)
                }

            }


            setOpenBackdrop(false);

        } else {
            console.log("ERRO AO TRAZER CONTAS DO ASSET")
        }



    }

    function doChangeFund(fund) {

        //console.log("INDEX: ", fund);
        if (fund?.id) {

            setInputFundNewTransaction(fund)
            loadFundAccounts(fund.id,
                clientOn.client.id, undefined);
        }

    }

    //A movimentação não pode ser alterada caso a carteira já tenha sido fechada
    function unableToChange() {

        return !isDateAfterClosedMonth(moment.utc(new Date(clientOn.client.selectedYear, parseInt(clientOn.client.selectedMonth) - 1, 1)).format("DD/MM/YYYY"),
            clientOn.client.portfolio_closed,
            false)
    }



    useEffect(() => {

        console.log("DATA NEW TRANSACTION: ", content)

        if (content.update) {

            setOpenBackdrop(true);

            //incicializando inputs
            //init dynamic inputs to update
            const { operation_id, is_transfer, is_split, transaction_date, amount, apr_description_id, apr_description } = content.transactionToUpdate;
            handleInputsToUpdate(operation_id, is_transfer, is_split, transaction_date, amount, apr_description_id, apr_description)
            setInputQuotasNewTransaction(content.transactionToUpdate.quota_value_transaction ? applyMaskAmount(content.transactionToUpdate.quota_value_transaction) : '');

            if (content && content.data && content.data.titleAssets) {
                const indexAssetTitleSelected = content.data.titleAssets.findIndex(el => el.id === content.transactionToUpdate.title_asset_id);
                if (indexAssetTitleSelected >= 0) {
                    setInputAssetTitleNewTransaction(indexAssetTitleSelected);
                }
            }

            if (content.transactionToUpdate.title_id) {
                setOption('title')
            }

            loadFundAccounts(content.transactionToUpdate.fund_id,
                clientOn.client.id,
                content.transactionToUpdate.account_id);

        } else {


            //Caso exista content.data.fundId vai para a Criação de nova movimentação
            const fundId = content.data.fund?.fund_id || content.data.funds[0].id;
            setInputFundNewTransaction({ id: fundId })
            loadFundAccounts(fundId,
                clientOn.client.id, undefined);


        }

    }, [])
    return (
        <div className={classes.root}>


            {
                !confirmingAction ?

                    <>
                        <Paper square className={classes.header}>
                            <IconButton
                                className={!content.update || !content.data.path ? classes.hiddenIcon : ""}
                                onClick={() => dispatch(allActions.rightContentActions.setRightContent(
                                    content.data,
                                ))}>
                                <ArrowBackIcon />
                            </IconButton>


                            <div>
                                <Typography
                                    variant={'h6'}
                                    align={'left'}>

                                    {content.update ? "Editar movimentação" : "Cadastrar Movimentação"}

                                </Typography>

                                {!content.update ?
                                    <ToggleButtonGroup
                                        style={{ marginTop: '8px' }}
                                        className={classes.toogleButton}
                                        exclusive value={option} onChange={handleSelect}>
                                        <ToggleButton value={'fund'}>
                                            {'Fundo'}
                                        </ToggleButton>
                                        <ToggleButton value={'title'}>
                                            {'Título Público'}
                                        </ToggleButton>

                                    </ToggleButtonGroup>
                                    : null
                                }


                                {/* <Typography
                        align={'left'}
                        className={classes.labelCellBottom}>
                        {content && content.data ? content.data.fund_name : ""}
                    </Typography> */}
                            </div>


                            <IconButton className={content.update && content.data.path ? classes.hiddenIcon : ""}
                                onClick={() => dispatch(allActions.rightContentActions.setRightContent(null))}>
                                <CloseIcon />
                            </IconButton>

                        </Paper>


                        <div className={classes.main}>

                            <Grid container spacing={2}>
                                {
                                    option == 'fund' ?
                                        <Grid item lg={12} md={12} sm={12} xs={12}>
                                            {
                                                content.update || content.data.fund ?

                                                    <MyInfo
                                                        outerlabel={'Fundo'}
                                                        label={content.data.fund?.fund_name || content.transactionToUpdate?.fund_name}>
                                                    </MyInfo>

                                                    :
                                                    <>
                                                        {
                                                            content.data && content.data.funds ?

                                                                <MyAutoComplete
                                                                    onChange={(event, newValue) => {
                                                                        doChangeFund(newValue)
                                                                    }}
                                                                    options={content.data.funds}
                                                                    autoComplete
                                                                    label={'Nome do fundo ou CNPJ'}
                                                                    filterOptions={(options, state) => {
                                                                        if (!options) return [];
                                                                        return options.filter(element => element.cnpj
                                                                            .includes(state.inputValue)
                                                                            || element.fund_name.toLowerCase().includes(state.inputValue.toLowerCase()));
                                                                    }}
                                                                    value={inputFundNewTransaction ? inputFundNewTransaction : null}
                                                                    getOptionLabel={(option) => option.fund_name}
                                                                    renderOption={(option) => (
                                                                        <React.Fragment key={'autocomplete-fund-new-transaction-' + option.id}>
                                                                            <span className={classes.bold}>{option.fund_name}</span>
                                                                        </React.Fragment>
                                                                    )}
                                                                    renderInput={(params) => <TextField {...params} margin="normal" variant="outlined" />}
                                                                />
                                                                // <MySelect
                                                                //     outerlabel={'Fundo'}
                                                                //     value={inputFundNewTransaction}
                                                                //     onChange={(e) => doChangeFund(e.target.value)}
                                                                //     options={content.data.funds.map((row, index) => (
                                                                //         <option key={'client-fund-' + row.id} value={index}>{row.fund_name}</option>
                                                                //     ))}
                                                                // /> 
                                                                : null
                                                        }
                                                    </>

                                            }
                                        </Grid>
                                        :
                                        <Grid item lg={12} md={12} sm={12} xs={12}>
                                            {
                                                content.update ?

                                                    <MyInfo
                                                        outerlabel={'Título'}
                                                        label={content.transactionToUpdate.title_name + " ( Aplicação: " + moment.utc(content.transactionToUpdate.purchase_date).format("DD/MM/YYYY") + ")"}>
                                                    </MyInfo>

                                                    :
                                                    <>
                                                        {
                                                            content.data && content.data.titleAssets ?
                                                                <MySelect
                                                                    outerlabel={'Título'}
                                                                    value={inputAssetTitleNewTransaction}
                                                                    onChange={(e) => setInputAssetTitleNewTransaction(e.target.value)}
                                                                    options={content.data.titleAssets.map((row, index) => (
                                                                        <option key={'client-title-asset-' + row.id} value={index}>{row.title_name + (row.trading_note ? ' [' + row.trading_note + ']' : "") + ' ( Aplicação: ' + moment.utc(row.purchase_date).format('DD/MM/YYYY') + " )"}</option>
                                                                    ))}
                                                                /> : null
                                                        }
                                                    </>

                                            }
                                        </Grid>



                                }

                                {
                                    option === 'fund' ?
                                        <Grid item lg={12} md={12} sm={12} xs={12}>
                                            {
                                                fundClientAccounts && fundClientAccounts.length > 1 ?

                                                    <MySelect
                                                        outerlabel={'Conta'}
                                                        value={inputAccountNewTransaction}
                                                        onChange={(e) => setInputAccountNewTransaction(e.target.value)}
                                                        initblank={inputAccountNewTransaction == undefined}
                                                        options={
                                                            fundClientAccounts.map((row, index) => (
                                                                <option key={'account-new-transaction-' + row.id} value={index}>
                                                                    {
                                                                        row.description + ' [ ' + applyMaskAccount(row.number_account) + ' ] [ ' + (row.agency ? row.agency : '-') + ' ]'
                                                                    }
                                                                </option>
                                                            ))
                                                        }
                                                    />

                                                    :
                                                    <>
                                                        {
                                                            fundClientAccounts && fundClientAccounts.length == 1 ?
                                                                <MyInfo
                                                                    outerlabel={'Conta'}
                                                                    label={`
                                                                ${fundClientAccounts[0].description} [ 
                                                                ${applyMaskAccount(fundClientAccounts[0].number_account)} ] 
                                                                ${fundClientAccounts[0].agency != null ? '[' + fundClientAccounts[0].agency + ']' : ''}`
                                                                    }>
                                                                </MyInfo>
                                                                : null
                                                        }
                                                    </>

                                            }
                                        </Grid>
                                        : null

                                }

                                {renderedInputsDatesAndValues}

                                {
                                    needQuotasTransaction ?

                                        <Grid item lg={4}
                                            md={4} sm={12} xs={12} className={classes.alignLeft}>
                                            <MyTextField
                                                align={'right'}
                                                size={'small'}
                                                outerlabel="Qtd. Cotas"
                                                outerlabelright={'true'}
                                                value={inputQuotasNewTransaction}
                                                placeholder="0,00"
                                                variant="outlined"
                                                helperText={"Insira o valor de qtd de cotas"}
                                                onChange={(value) => setInputQuotasNewTransaction(value)} />

                                        </Grid> : null
                                }

                                {
                                    option == 'fund' && !content?.update &&
                                    <Grid item lg={12} md={12} sm={12} xs={12}>

                                        <UnoButton
                                            float="right"
                                            size="verySmall"
                                            startIcon={<AddIcon />}
                                            onClick={() => handleAddInputDateAndValueFund()}
                                            type='defaultClean'>
                                            {"Adicionar registro"}
                                        </UnoButton>
                                    </Grid>
                                }

                            </Grid>

                            <br />

                            {
                                !unableToChange() ?
                                    <div className={classes.bottom}>

                                        {
                                            validationMessage != '' ?
                                                <Typography className={classes.validationMessage}>
                                                    {validationMessage}
                                                </Typography>
                                                : null

                                        }

                                        {content.update ?

                                            <div className={'bottomButtons'}>


                                                <UnoButton
                                                    className={
                                                        !content.update ? classes.hiddenIcon : null}
                                                    onClick={() => setConfirmingAction(true)}
                                                    type='errorClean'>
                                                    {"Excluir movimentação"}
                                                </UnoButton>
                                                <UnoButton
                                                    onClick={() => doUpdateTransaction()}
                                                    type='success'>
                                                    {"Atualizar movimentação"}
                                                </UnoButton>
                                            </div>

                                            :
                                            <UnoButton
                                                onClick={() => option == 'fund' ? doCreateFundTransaction() : doCreateTitleTransaction()}
                                                type='primary'>
                                                {inputsDatesAndValuesFundTransactions.length == 1 ? "Salvar movimentação" : `Salvar movimentações [${inputsDatesAndValuesFundTransactions.length}]`}
                                            </UnoButton>
                                        }


                                    </div>
                                    : null
                            }

                            {/* //em caso de transação inválida permitir excluir */}

                            {
                                (content
                                    && content.transactionToUpdate
                                    && content.transactionToUpdate.invalidTransaction
                                    && checkUserIsRole(currentUser, [roles.admin, roles.superadmin])
                                ) ?

                                    <UnoButton
                                        className={
                                            !content.update ? classes.hiddenIcon : null}
                                        onClick={() => setConfirmingAction(true)}
                                        type='errorClean'>
                                        {"Excluir movimentação"}
                                    </UnoButton> : null
                            }


                        </div>


                    </>
                    :
                    <ConfirmActionRightContent
                        message={`Tem certeza que quer excluir essa movimentação?`}
                        handleCancel={() => setConfirmingAction(false)}
                        handleConfirm={() => doDeleteTransaction()}
                    />
            }

            {
                openBackdrop ?
                    <div className={classes.rightDivBackdrop}>
                        <CircularProgress className={'progress'} />
                    </div> : null
            }


        </div>
    );
}



